'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var get=function(object,path){for(var keys=path.split('.'),index=0,resultObject=object;index<keys.length;){var key=keys[index++];resultObject=resultObject[key]}return index&&index===keys.length?resultObject:void 0},translate=function(id,values,messages){var func=get(messages,id);return func(values)};exports.default=translate;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/i18n/translate.js
 **/